import { render, staticRenderFns } from "./community-access-form.vue?vue&type=template&id=5f6a7490&scoped=true"
import script from "./community-access-form.vue?vue&type=script&lang=js"
export * from "./community-access-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a7490",
  null
  
)

export default component.exports